import * as Types from '../../types';

import { gql } from '@apollo/client';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContractsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetContractsQuery = {
  __typename?: 'Query';
  contracts: {
    __typename?: 'ContractConnection';
    edges: Array<{
      __typename?: 'ContractEdge';
      cursor: string;
      node: {
        __typename?: 'Contract';
        name?: string | null;
        chainId: number;
        deploymentBlock: number;
        createdAt: any;
        address: {
          __typename?: 'Address';
          address: string;
          entity?: {
            __typename?: 'Entity';
            id: any;
            name: string;
            risks: {
              __typename?: 'EntityRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'EntityRiskEdge';
                node: {
                  __typename?: 'EntityRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          risks: {
            __typename?: 'AddressRiskConnection';
            totalCount: number;
            pageInfo: {
              __typename?: 'PageInfo';
              hasNextPage: boolean;
              hasPreviousPage: boolean;
              startCursor?: string | null;
              endCursor?: string | null;
            };
            edges: Array<{
              __typename?: 'AddressRiskEdge';
              node: {
                __typename?: 'AddressRisk';
                id: any;
                riskType: string;
                severity: string;
                description?: string | null;
              };
            }>;
          };
        };
        deployer: {
          __typename?: 'Address';
          address: string;
          entity?: {
            __typename?: 'Entity';
            id: any;
            name: string;
            risks: {
              __typename?: 'EntityRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'EntityRiskEdge';
                node: {
                  __typename?: 'EntityRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          risks: {
            __typename?: 'AddressRiskConnection';
            totalCount: number;
            pageInfo: {
              __typename?: 'PageInfo';
              hasNextPage: boolean;
              hasPreviousPage: boolean;
              startCursor?: string | null;
              endCursor?: string | null;
            };
            edges: Array<{
              __typename?: 'AddressRiskEdge';
              node: {
                __typename?: 'AddressRisk';
                id: any;
                riskType: string;
                severity: string;
                description?: string | null;
              };
            }>;
          };
        };
        abi?: { __typename?: 'ContractAbi'; id: any } | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    totalCount: number;
  };
};

export const GetContractsDocument = gql`
  query GetContracts($after: String, $before: String, $first: Int, $last: Int) {
    contracts(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          address {
            ...AddressDisplay
          }
          name
          chainId
          deployer {
            ...AddressDisplay
          }
          deploymentBlock
          createdAt
          abi {
            id
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetContractsQuery__
 *
 * To run a query within a React component, call `useGetContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractsQuery,
    GetContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractsQuery, GetContractsQueryVariables>(
    GetContractsDocument,
    options,
  );
}
export function useGetContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractsQuery,
    GetContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractsQuery, GetContractsQueryVariables>(
    GetContractsDocument,
    options,
  );
}
export function useGetContractsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetContractsQuery,
        GetContractsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContractsQuery, GetContractsQueryVariables>(
    GetContractsDocument,
    options,
  );
}
export type GetContractsQueryHookResult = ReturnType<
  typeof useGetContractsQuery
>;
export type GetContractsLazyQueryHookResult = ReturnType<
  typeof useGetContractsLazyQuery
>;
export type GetContractsSuspenseQueryHookResult = ReturnType<
  typeof useGetContractsSuspenseQuery
>;
export type GetContractsQueryResult = Apollo.QueryResult<
  GetContractsQuery,
  GetContractsQueryVariables
>;
